import { ConsentDialogLink } from 'c15t/react';
import { Text } from '@belong/ui';
import { STRINGS } from '../../strings';

/**
 * The CCPA opt-out surface in the site footer. Opt-in consent up front does not
 * replace it: someone who accepted keeps a standing right to opt out later.
 */
export function ConsentPreferencesLink() {
  return (
    <ConsentDialogLink className="flex cursor-pointer items-center justify-start rounded p-0 text-left font-semibold uppercase text-navy transition-colors duration-hover hover:text-dark-navy focus:text-dark-navy active:text-dark-navy lg:justify-center">
      <Text as="span" variant="body" fontWeight="semibold" className="lg:p1">
        {STRINGS.privacyChoices}
      </Text>
    </ConsentDialogLink>
  );
}
